import { render } from "./Phone.vue?vue&type=template&id=45c5d53c"
import script from "./Phone.vue?vue&type=script&lang=js"
export * from "./Phone.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "45c5d53c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45c5d53c', script)) {
    api.reload('45c5d53c', script)
  }
  
  module.hot.accept("./Phone.vue?vue&type=template&id=45c5d53c", () => {
    api.rerender('45c5d53c', render)
  })

}

script.__file = "src/icons/components/filled/Phone.vue"

export default script